<template>
    <div>
        <div class="container-fluid mt-5 mb-6 mt-lg-6 mb-lg-9">
            <div class="row justify-content-center">
                <div class="col-xl-6 order-xl-1">
                    <card shadow type="secondary" v-if="user">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-12">
                                    <h3 class="mb-0">{{ $t('remove_account') }}</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form role="form">
                                <div class="pl-lg-4">
                                    <div class="row" v-if="userRemoved">
                                        <div class="col-lg-12">
                                            <base-alert type="success" dismissible="true">
                                                Аккаунт успешно измененен.
                                            </base-alert>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        :label="$t('email')"
                                                        :placeholder="`${$t('enter_your_email')}*`"
                                                        input-classes="form-control-alternative"
                                                        :error="fieldError('email')"
                                                        v-model="email"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        :label="$t('password')"
                                                        :placeholder="`${$t('enter_your_password')}*`"
                                                        input-classes="form-control-alternative"
                                                        type="password"
                                                        :error="fieldError('password')"
                                                        v-model="password"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="text-center">
                                                <base-button :disabled="!submitEnabled || loading" type="primary" class="my-4"
                                                             @click="submitConfirm">{{ $t('remove_account') }}
                                                </base-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>

                        </template>
                    </card>
                </div>
            </div>
        </div>
        <modal
                :show="confirmDialog"
        >
            <template v-slot:header>
                <h2>{{ $t('are_you_shure_want_remove_account') }}</h2>
            </template>
            <p>{{ $t('remove_account_notice') }}</p>
            <template v-slot:footer>
                <base-button type="secondary" @click="confirmDialog = false" :disabled="loading">{{ $t('cancel') }}</base-button>
                <base-button type="danger" @click="submit" :disabled="loading">{{ $t('remove') }}</base-button>
            </template>
        </modal>
    </div>
</template>
<script>
    import {destroyUser, getUser} from "../data/jwt.service";
    import userApi from "../data/UserApi";

    export default {
        name: 'user-remove',
        data() {
            return {
                user: null,
                email: '',
                password: '',

                userRemoved: null,

                confirmDialog: false,

                error: null,
                fieldsErrors: [],
                loading: false,
            }
        },

        computed: {
            submitEnabled() {
                return this.email && this.email.length > 0
                    && this.password && this.password.length > 0
            },
        },

        mounted() {
            this.user = getUser()
        },

        methods: {
            submitConfirm() {
                this.confirmDialog = true
            },

            submit() {
                this.error = null
                this.fieldsErrors = []
                this.loading = true
                userApi.remove(this.email, this.password)
                    .then(response => {
                        this.confirmDialog = false
                        this.userRemoved = response
                        destroyUser()
                        this.$router.push('/user/signin')
                    })
                    .catch(error => {
                        this.confirmDialog = false
                        let data = error.response.data
                        if (error.response.status === 422) {
                            this.fieldsErrors = data
                        } else if (error.response.status === 401) {
                            this.error = this.$t('error_invalid_login')
                        } else {
                            this.error = this.pretty(data)
                        }
                        this.loading = false
                    })
            },

            fieldError(fieldName) {
                let errors = []
                if (this.fieldsErrors) {
                    this.fieldsErrors.filter(field => {
                        if (field.field === fieldName) {
                            errors.push(field.message)
                        }
                    })
                }
                if (errors.length > 0)
                    return errors.join(', ')
                return null
            },
            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },
        }
    };
</script>
<style></style>
